<div class="header">
    <div class="header__logo">
        <img src="../../assets/stokker_logo_transparent.png" alt="Stokker logo">

    </div>
    <a class="header__bell" routerLink="/ertesitesek" title="Értesítések" [class.header__bell--on]="notifUnread > 0">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M6 16 V11 a6 6 0 0 1 12 0 v5 l1.5 2 H4.5 Z"></path><path d="M10 20 a2 2 0 0 0 4 0"></path></svg>
        <span class="header__bell-count" *ngIf="notifUnread > 0">{{ notifUnread > 99 ? '99+' : notifUnread }}</span>
    </a>
    <div class="menu-btn" (click)="navigationService.toggleNavVisibility()" [class.opened]="navigationService.isNavOpened()">
        <span class="menu-btn__line1"></span>
        <span class="menu-btn__line2"></span>
    </div>
</div>
